/*
 *
 * OrderOperationDetail
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 02-Jul-2024
 */

import OperationDetailContainer from './OperationDetailContainer'

export default OperationDetailContainer
